import React from "react";
import AutoComplete from "material-ui/AutoComplete";

export default class CustomAutoComplete extends React.PureComponent {
    constructor(props) {
        super(props);
        this._handleUpdateInput = this._handleUpdateInput.bind(this);
        this._handleNewRequest = this._handleNewRequest.bind(this);
    }

    _handleUpdateInput(...args) {
        const { onUpdateInput = () => {} } = this.props;
        if (args[2] && args[2].source === "change") {
            onUpdateInput.apply(this, args);
        }
    }

    _handleNewRequest(...args) {
        const { onNewRequest = () => {} } = this.props;
        onNewRequest.apply(this, args);
    }

    render() {
        const {
            id = "",
            floatingLabelFixed = false,
            menuProps = {},
            floatingLabelText = "",
            hintText = "",
            animated = false,
            style = {},
            listStyle = {},
            menuStyle = {},
            textFieldStyle = {},
            searchText = "",
            dataSource = [],
            dataSourceConfig = {},
            disabled = false,
            filter
        } = this.props;

        return (
            <AutoComplete
                {...this.props}
                id={id}
                floatingLabelFixed={floatingLabelFixed}
                menuProps={Object.assign({}, menuProps)}
                floatingLabelText={floatingLabelText}
                hintText={hintText}
                animated={animated}
                filter={filter || AutoComplete.caseInsensitiveFilter}
                style={Object.assign({}, style)}
                listStyle={Object.assign({}, listStyle)}
                menuStyle={Object.assign({}, menuStyle)}
                textFieldStyle={Object.assign({}, textFieldStyle)}
                searchText={searchText}
                dataSource={dataSource}
                dataSourceConfig={Object.assign({}, dataSourceConfig)}
                disabled={disabled}
                autoComplete="off"
                onUpdateInput={this._handleUpdateInput}
                onNewRequest={this._handleNewRequest}
            />
        );
    }
}
